import { create } from 'zustand'

type HomeAddGroupState = {
  groupName: string | null
  nameBorderColor: string
  notAllowedGroupName: boolean
  nameTooLong: boolean
  nameDuplicated: boolean
  isSubmitting: boolean
}

type HomeAddGroupAction = {
  setGroupName: (groupName: string | null, existingNames: string[]) => void
  setNameBorderColor: () => void
  setIsSubmitting: (isSubmitting: boolean) => void
  reset: () => void
}

const initialState: HomeAddGroupState = {
  groupName: null,
  nameBorderColor: 'border border-tdpldarkgrey',
  notAllowedGroupName: false,
  nameTooLong: false,
  nameDuplicated: false,
  isSubmitting: false,
}

const useHomeAddGroupStore = create<HomeAddGroupState & HomeAddGroupAction>((set) => ({
  ...initialState,
  setGroupName: (groupName, existingNames) => {
    set(() => ({
      groupName: groupName === '' ? null : groupName,
      notAllowedGroupName: groupName !== null && groupName.includes('$'),
      nameTooLong: groupName !== null && groupName.length > 20,
      nameBorderColor: 'border border-tdpldarkgrey',
      nameDuplicated: groupName ? existingNames.includes(groupName) : false,
    }))
  },
  setNameBorderColor: () => {
    set((state) => ({
      nameBorderColor:
        state.groupName === null ||
        state.groupName.includes('$') ||
        state.groupName.length > 20 ||
        state.nameDuplicated
          ? 'border-2 border-tdplmaroon data-[hover=true]:border-tdplmaroon'
          : 'border border-tdpldarkgrey',
    }))
  },
  setIsSubmitting: (isSubmitting) => {
    set({ isSubmitting })
  },
  reset: () => {
    set(initialState)
  },
}))

export default useHomeAddGroupStore
